module.exports = __webpack_public_path__ + "32e865c1ada11dc1a1621c2506b3e6c9.png";